import React from "react";
import Achievement from "./Achievement/Achievement";
import GraphicKhabar from "./GraphicKhabar/GraphicKhabar";
import KycPayment from "./Kyc-Payment/Kyc-Payment";
import MiniServices from "./MiniServices/MiniServices";
import Notice from "./Notice/Notice";
import Services from "./Services/Services";
import Testomonials from "./Testonomials/Testonomials";
import Carousel from "./Carousel/Carousel";
import HeaderText from "./HeaderText/HeaderText";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";


const Home = () => {

  const { user } = useSelector((state) => state.auth);
  return (
    <>

      <div className="mt-4">
        {
          // user.user_type === "CL" && <KycPayment />
          user && (user.user_type === "CL" && <KycPayment />)
        }
        {/* <KycPayment /> */}

        <HeaderText />

        {/* <div className="flex">
        <Carousel />
            <Notice />

        </div> */}
        <header className="  lg:flex">
          <div className="lg:flex-row flex flex-col flex-1 gap-4 px-2 lg:px-6">
            <Carousel />
            <Notice />
          </div>
        </header>

        <MiniServices />
        <Services />
        <Achievement />
        <GraphicKhabar />
        <Testomonials />
      </div>
    </>
  );
};

export default Home;
